import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import BookingSection from '../components/ExteriorCleaningLanding/BookingSection'
import CampaignStrategy from '../components/ExteriorCleaningLanding/CampaignStrategy'
import ExteriorCleaningHero from '../components/ExteriorCleaningLanding/ExteriorCleaningHero'
import FAQ from '../components/ExteriorCleaningLanding/FAQ'
import HowItWorks from '../components/ExteriorCleaningLanding/HowItWorks'
import SocialProof from '../components/ExteriorCleaningLanding/SocialProof'
import WhyOLM from '../components/ExteriorCleaningLanding/WhyOLM'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'

const EXTERIOR_CLEANING_FALLBACK_META = `
<meta name="description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
<meta property="og:title" content="Direct Mail Marketing That Works" />
<meta property="og:description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
`

export default function ExteriorCleaning({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header
                meta={data?.yoast_head || EXTERIOR_CLEANING_FALLBACK_META}
                metaTitle="Direct Mail Marketing That Works"
            />
            <ExteriorCleaningHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .exterior-cleaning-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .exterior-cleaning-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .exterior-cleaning-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/exterior-cleaning')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            hideCartButton: true,
            hideLoginButton: true,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
